import QScrollbar from './src/main';

export default QScrollbar;
